import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs/Observable";
import 'rxjs/Rx';
import 'rxjs/add/operator/catch';


import * as _ from 'lodash';
import { EndpointFactory } from "./endpoint-factory.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ConfigurationService } from "./configuration.service";
import { extend } from "jquery";

@Injectable()
export class ProductService extends EndpointFactory {
    private _baseURL = '';


    constructor(public http: HttpClient, configurations: ConfigurationService, injector: Injector) {
        super(http, configurations, injector);
    }



    uploadTemplateFile(f: any) {

        //var options = this.commonService.getAuthHeader(false);
        //var blob = this.dataURItoBlob(dataURL);
        //var fd = new FormData(document.forms[0]);
        //fd.append(f.name, f, f.name);

        //return this.http.post(this._baseURl + '/api//upload-file/' + clientId, fd, this.getRequestHeaders(false)).catch(error => {
        //    return this.handleError(error, null);
        //});
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/product.service.ts